/* eslint-disable */
import appmetricaParams from './appmetricaParams';

const APPMETRICA_URLS = {
	ios: 'https://redirect.appmetrica.yandex.com/serve/461983867696375575',
	android: 'https://redirect.appmetrica.yandex.com/serve/894329423652792694',
	appgallery: 'https://redirect.appmetrica.yandex.com/serve/29640983511635245'
};

/**
 * Generates AppMetrica redirect URL with tracking parameters
 * @param {string} bannerName
 * @param {string} deviceType
 * @param {string} partner
 * @returns {string}
 */
const appmetricaService = (bannerName, deviceType = 'android', partner = 'desktop') => {
	const normalizedDeviceType = deviceType.toLowerCase();
	const url = APPMETRICA_URLS[normalizedDeviceType] || APPMETRICA_URLS.android;

	return `${url}?${appmetricaParams(bannerName, partner)}`;
};

$(function () {
	$('body').on('click', '.js-banner-appmetrica', function (e) {
		e.preventDefault();

		const $this = $(this);
		const bannerName = $this.data('banner-name');
		const deviceType = $this.data('device-type') || 'android';
		const partner = $this.data('partner') || 'desktop';

		const url = appmetricaService(bannerName, deviceType, partner);
    console.log(url);
		window.open(url, '_blank');

		return false;
	});
});

export default appmetricaService;
